<template>
  <div>
    <el-form
      :model="blogForm"
      :rules="rules"
      ref="blogForm"
      label-width="170px"
    >
      <el-row>
        <el-col :span="24">
          <el-form-item label="赛事类别：" prop="classId">
            <el-select
              v-model="blogForm.classId"
              placeholder="请选择"
              clearable
            >
              <el-option
                v-for="(item, index) in options"
                :key="index"
                :label="item.title"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="20">
          <el-form-item label="赛事头图：" prop="">
            <el-radio v-model="format" label="1">引用图片链接</el-radio>
            <el-radio v-model="format" label="2">本地上传</el-radio>
          </el-form-item>
        </el-col>
        <!-- <el-col :span="4">
          <div class="float-right">
         
          </div>
        </el-col> -->
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item v-if="format == 1" label="缩略图：" prop="imgUrlLink">
            <el-input
              max="1000"
              style=""
              v-model="blogForm.imgUrlLink"
            ></el-input>
          </el-form-item>
          <el-form-item v-else label="缩略图：" prop="imgUrl">
            <el-upload
              class="avatar-uploader"
              name="img"
              :action="$http.defaults.baseURL + '/upload'"
              :show-file-list="false"
              :on-success="handleAvatarSuccess"
              :before-upload="beforeAvatarUpload"
            >
              <el-image
                v-if="blogForm.imgUrl"
                :src="
                  blogForm.imgUrl.includes('cnd.saishiquan.cn')
                    ? blogForm.imgUrl
                    : $http.defaults.resource + blogForm.imgUrl
                "
                fit="contain"
                class="avatar"
              ></el-image>
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="24">
          <el-form-item label="赛事名称：" prop="title">
            <el-input v-model="blogForm.title"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="举办地：" prop="hostCity">
            <el-input
              v-if="admins.power"
              class="selectLocation"
              style="width: 600px"
              :maxlength="200"
              v-model="blogForm.hostCity"
            >
              <el-button
                slot="append"
                size="mini"
                type="primary"
                @click="openMapDialog"
                >选择位置</el-button
              ></el-input
            >
            <span
              style="margin-right: 10px"
              v-if="blogForm.hostCity && !admins.power"
              >{{ blogForm.hostCity }}</span
            >
            <el-button
              v-if="!admins.power"
              size="mini"
              type="primary"
              @click="openMapDialog"
              >选择位置</el-button
            >

            <newMap ref="bmapAddressSelect" @confirmOn="ensureOn"></newMap>
            <!-- <el-input :maxlength="200" v-model="blogForm.hostCity"></el-input> -->
            <!-- <Map ref="map" @updateLocation="updateLocation" /> -->
            <!-- <testMap></testMap> -->
            <!-- <geographicalMap @confirmOn="ensureOn" ref="bmapAddressSelect"></geographicalMap> -->
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="联系方式：" prop="matchOrganizer">
            <el-input
              :maxlength="200"
              v-model="blogForm.matchOrganizer"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="赛事时间：" prop="matchTime">
            <el-date-picker
              v-model="blogForm.matchTime"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="举办情况：" prop="views">
            <el-select
              style="width: 100%"
              v-model="blogForm.status"
              placeholder="请选择"
            >
              <el-option label="如期举行" value="0"> </el-option>
              <el-option label="取消" value="1"> </el-option>
              <el-option label="延期" value="2"> </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <!-- <el-row>
        <el-col :span="12">
          <el-form-item
            label="跳转链接："
            prop="signUpUrl"
          >
            <el-input
              v-model="blogForm.signUpUrl"
              placeholder="请输入关联的公众号文章链接"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            label="热度："
            prop="views"
          >
            <el-input-number
              v-model="blogForm.follows"
              :min="0"
              :max="1000000"
              label="请输入热度"
            ></el-input-number>
          </el-form-item>
        </el-col>

      </el-row> -->
      <el-row>
        <el-col :span="24">
          <el-form-item label="开启报名：">
            <el-switch v-model="blogForm.openSignUp"> </el-switch>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item v-if="blogForm.openSignUp" label="报名项目：" required>
            <el-tag
              :key="tag"
              v-for="tag in projectTags"
              :disable-transitions="false"
            >
              {{ tag.name + "￥" + tag.money }}
            </el-tag>
            <el-button
              class="button-new-tag"
              size="small"
              @click="dialogRegistrationItems = !dialogRegistrationItems"
              ><i class="el-icon-edit"></i> 编辑</el-button
            >
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="blogForm.openSignUp">
          <el-row>
            <el-form-item label="报名表单：">
              <el-tag
                :key="index"
                v-for="(tag, index) in addedTags"
                :disable-transitions="false"
              >
                {{ tag.name }}
              </el-tag>
              <el-button
                class="button-new-tag"
                size="small"
                @click="dialogAddedItems = !dialogAddedItems"
                ><i class="el-icon-edit"></i> 编辑</el-button
              >
            </el-form-item>
          </el-row>
        </el-col>
        <el-col :span="12" v-if="blogForm.openSignUp">
          <el-form-item label="报名表单修改截止时间：">
            <el-date-picker
              v-model="blogForm.infoEndTime"
              type="datetime"
              placeholder="选择日期时间"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="开启团报：">
            <el-switch v-model="blogForm.openUnite"> </el-switch>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item v-if="blogForm.openUnite" label="团报优惠：" required>
            <el-tag
              :key="tag"
              v-for="tag in uniteTags"
              :disable-transitions="false"
            >
              {{
                tag.money +
                "  " +
                tag.discountRatio +
                "%  " +
                tag.numberRange[0] +
                "-" +
                tag.numberRange[1]
              }}
            </el-tag>
            <el-button
              class="button-new-tag"
              size="small"
              @click="dialogUniteItems = !dialogUniteItems"
              ><i class="el-icon-edit"></i> 编辑</el-button
            >
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item v-if="blogForm.openUnite" label="团报截止时间：">
            <el-button
              class="button-new-tag"
              size="small"
              @click="dialogProjectSet = !dialogProjectSet"
              ><i class="el-icon-edit"></i> 编辑</el-button
            >
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="用户退款：">
            <el-switch v-model="blogForm.isRefund"> </el-switch>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            prop="refundRatio"
            v-if="blogForm.isRefund"
            label="退款比例："
          >
            <el-input-number
              v-model="blogForm.refundRatio"
              controls-position="right"
              :min="0"
              :max="100"
              :precision="2"
            >
            </el-input-number>
            <span style="margin-left: 10px">%</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            prop="refundeEnd"
            v-if="blogForm.isRefund"
            label="退款截止时间："
          >
            <el-date-picker
              v-model="blogForm.refundeEnd"
              type="datetime"
              placeholder="选择日期时间"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <!-- <el-col :span="24">
          <el-form-item label="组队：">
            <el-switch v-model="blogForm.openTeam"> </el-switch>
          </el-form-item>
        </el-col> -->
        <el-col :span="24">
          <el-form-item label="报名须知：">
            <el-input
              type="textarea"
              :rows="5"
              placeholder="请输入报名须知"
              v-model="blogForm.noticeText"
            >
            </el-input>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item label="赛事标签：">
            <el-select
              v-model="blogForm.relateLabel"
              multiple
              style="width: 100%"
              filterable
              placeholder="请选择标签"
            >
              <el-option
                v-for="item in labelList"
                :key="item.id"
                :label="item.title"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8" v-if="admins.power">
          <el-form-item label="评分：">
            <el-input-number
              v-model="blogForm.score"
              :precision="2"
              :step="0.1"
              :max="5"
              :min="0"
            ></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="8" v-if="admins.power">
          <el-form-item label="评分人数：">
            <el-input-number
              v-model="blogForm.scoreNumber"
              :max="100000"
            ></el-input-number>
          </el-form-item>
        </el-col>

        <!-- <el-row v-if="admins.power">
          <el-form-item label="开启抽奖：">
            <el-switch v-model="blogForm.openLottery">
            </el-switch>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item
            v-if="blogForm.openLottery"
            label="抽奖时间："
            prop="lotteryTime"
          >
            <el-date-picker
              v-model="blogForm.lotteryTime"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item
            v-if="blogForm.openLottery"
            prop="lotteryNumber"
            label="奖品数量："
          >
            <el-input-number
              v-model="blogForm.lotteryNumber"
              :precision="0"
              :step="1"
              :max="100000000"
            ></el-input-number>
          </el-form-item>
        </el-row> -->
      </el-row>
      <el-row>
        <!-- <el-col :span="12">
          <el-form-item label="小程序解析器：">
            <el-radio v-model="blogForm.parser" label="1">mp-html</el-radio>
            <el-radio v-model="blogForm.parser" label="2">towxml</el-radio>
            <el-radio v-model="blogForm.parser" label="3">parser</el-radio>
          </el-form-item>
        </el-col> -->
        <!-- <el-col :span="12">
          <el-form-item label="导入公众号文章：">
            <el-input
              v-model="articleUrl"
              placeholder="以https开头的公众号文章"
            >
              <el-button
                slot="append"
                @click="sendArticleUrl"
              >导入</el-button>
            </el-input>
          </el-form-item>
        </el-col> -->
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="介绍：">
            <!-- <el-input v-model="html" type="textArea"></el-input> -->
            <el-radio v-model="blogForm.introduceType" label="1"
              >图文详情</el-radio
            >
            <el-radio v-model="blogForm.introduceType" label="2"
              >公众号推文链接</el-radio
            >
            <a style="margin-left: -10px" class="link">如何上传公众号推文?</a>
            <div style="margin-top: 20px">
              <el-input
                v-if="blogForm.introduceType == 2"
                v-model="blogForm.weixinLink"
                placeholder="将微信公众号报名/介绍推文复制到此"
                type="textArea"
              ></el-input>
              <ckEditor
                v-model="html"
                v-if="blogForm.introduceType == 1"
              ></ckEditor>
            </div>
            <!-- <Cherry :height='800' v-model='html'/> -->
            <!-- 布局乱 -->
            <!-- <Toolbar
                style="border-bottom: 1px solid #ccc"
                :editor="editor"
                :defaultConfig="toolbarConfig"
                :mode="mode">
               <Editor
                  @customPaste="customPaste"
                style="height: 500px; overflow-y: hidden;"
                v-model="html"
                :defaultConfig="editorConfig"
                :mode="mode"
                @onCreated="onCreated"
              />  -->
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div class="btn-footer">
      <!-- <el-button type="info" @click="cancel">取消</el-button> -->
      <el-button type="primary" @click="issueBlog('blogForm')"
        >修改赛事</el-button
      >
    </div>
    <registrationItems
      v-if="dialogRegistrationItems"
      :registTime="blogForm.registTime"
      :visible.sync="dialogRegistrationItems"
      v-model="projectTags"
    ></registrationItems>
    <uniteItems
      :visible.sync="dialogUniteItems"
      :options="projectTags"
      v-model="uniteTags"
    ></uniteItems>
    <groupProjectSet
      :visible.sync="dialogProjectSet"
      v-model="projectTags"
    ></groupProjectSet>
    <addedItems
      v-if="dialogAddedItems"
      :visible.sync="dialogAddedItems"
      :formCheckList="formCheckList"
      @changeFormCheckList="changeFormCheckList"
      :options="projectTags"
      v-model="addedTags"
    ></addedItems>
  </div>
</template>

<script>
import ckEditor from "@/components/ckEditor.vue";
import registrationItems from "./registrationItems/index.vue";
import Map from "@/components/amap.vue";
// import testMap from '@/components/testMap.vue'
import newMap from "@/components/newMap.vue";
// import Cherry from "@/components/cherry.vue";
import geographicalMap from "@/components/map.vue";
import uniteItems from "./uniteItems/index.vue";
import groupProjectSet from "./groupProjectSet/index.vue";
import addedItems from "./addedItems/index.vue";

// import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
// import E from "wangeditor";
export default {
  components: {
    addedItems,
    Map,
    newMap,
    // testMap,
    registrationItems,
    uniteItems,
    groupProjectSet,
    ckEditor,
    geographicalMap,
    // Cherry,
  },
  data() {
    return {
      admins: JSON.parse(localStorage.getItem("admins")),
      projectTags: [],
      addedTags: [],
      uniteTags: [],
      dialogProject: false,
      dialogRegistrationItems: false,
      dialogUniteItems: false,
      dialogProjectSet: false,
      dialogAddedItems: false,
      formProject: {
        name: "",
        money: 0,
      },
      formCheckList: [
        "name",
        "gender",
        "phone",
        "region",
        "address",
        "birthDate",
        "identity",
        "identityNum",
        "size",
        "blood",
        "emerg",
        "emergNum",
      ],
      format: "1",
      blogForm: {
        parser: "1",
        classId: "",
        imgUrlLink: "",
        // 博客标题
        imgUrl: "",
        title: "",
        hostCity: "",
        matchName: "",
        matchPlace: "",
        matchOrganizer: "",
        refundRatio: 100,
        matchTime: [],
        registTime: [],
        signUpUrl: "",
        follows: 0,
        lotteryNumber: 0,
        introduce: "",
        status: "0",
        openUnite: false,
        openSignUp: false,
        openLottery: false,
        lotteryTime: [],
        isRefund: 0,
        openTeam: 0,
        noticeText: "",
        weixinLink: "",
        relateLabel: [],
        situatio: [],
        refundeEnd: null,
        infoEndTime: null,
        score: 0,
        scoreNumber: 0,
        introduceType: "1",
      },
      projectRules: {
        name: [{ required: true, message: "请输入项目名称" }],
        money: [{ required: true, message: "请输入项目金额" }],
      },
      rules: {
        // imgUrlLink: [
        //   {
        //     required: true,
        //     message: "请输入图片链接",
        //     trigger: "blur",
        //   },
        // ],
        imgUrl: [
          {
            required: true,
            message: "请上传图片",
            trigger: "blur",
          },
        ],
        classId: [{ required: true, message: "请选择分类", trigger: "blur" }],
        title: [
          { required: true, message: "请输入赛事名称", trigger: "blur" },
          {
            min: 3,
            max: 200,
            message: "长度在 3 到 200 个字符",
            trigger: "blur",
          },
        ],
        hostCity: [
          { required: true, message: "请填写举办地", trigger: "blur" },
        ],
        matchTime: [
          { required: true, message: "请选择赛事时间", trigger: "blur" },
        ],
        lotteryTime: [
          { required: true, message: "请选择抽奖时间", trigger: "blur" },
        ],
        registTime: [
          { required: true, message: "请选择报名时间", trigger: "blur" },
        ],
        lotteryNumber: [
          { required: true, message: "请输入奖品数量", trigger: "blur" },
        ],
        refundeEnd: [
          { required: true, message: "请选择退款截止时间", trigger: "blur" },
        ],
        refundRatio: [
          { required: true, message: "请填写退款比例", trigger: "blur" },
        ],
      },
      // 博客分类数组
      classArr: [],
      options: [],
      labelList: [],
      articleUrl: "",
      // 富文本实例
      // editor: null,
      html: "",
      center: { lng: "", lat: "" },
      address: "",
      // toolbarConfig: {},
      // editorConfig: {
      //   online: true,
      //   placeholder: "请输入内容...",
      //   MENU_CONF: {
      //     uploadImage: {
      //       server: this.$http.defaults.baseURL + "/upload",
      //       maxFileSize: 20 * 1024 * 1024,
      //       fieldName: "img",
      //       headers: { Accept: "multipart/form-data" },
      //       customInsert: (result, insertImg) => {
      //         // 上传成功 result为后台处理函数返回的数据
      //         var url = this.$http.defaults.resource + result.data;
      //         insertImg(url); //根据返回的图片路径，将图片插入到页面中，回显
      //       },
      //       // 上传错误，或者触发 timeout 超时
      //       onError: (file, err, res) => {
      //         // JS 语法
      //         console.log(`${file.name} 上传出错`, err, res);
      //         this.$message.error("图片太大");
      //       },
      //     },
      //   },
      // },
      mode: "default", // or 'simple'
    };
  },
  watch: {
    "blogForm.openSignUp"(val) {
      // 监听
      if (val) {
        if (this.admins.isPartner === 1 && !this.admins.sub_mchid) {
          this.blogForm.openSignUp = false;
          this.$message.info("请先申请特约商户");
          return;
        }
        if (
          this.admins.isPartner === 1 &&
          this.admins.sub_mchid &&
          this.admins.applyment_state !== "APPLYMENT_STATE_FINISHED"
        ) {
          this.$message.info("特约商户还未完成入驻");
        }
        if (
          this.admins.isPartner === 1 &&
          this.admins.sub_mchid &&
          this.admins.applyment_state === "APPLYMENT_STATE_FINISHED" &&
          this.admins.allocation_authorization == 0
        ) {
          this.blogForm.openSignUp = false;
          this.$message.info("请联系赛事圈管理员授权");
          return;
        }
      }
    },
  },
  created() {
    if (this.$route.query.id) {
      this.getDetail(this.$route.query.id);
    }
  },
  mounted() {
    this.getLabel();
    // this.createWangEditor();
    this.getClass();
    window.addEventListener("beforeunload", this.beforeUnloadHandler, false);
  },
  destroyed() {
    window.removeEventListener("beforeunload", this.beforeUnloadHandler, false);
  },
  methods: {
    updateLocation() {},
    ensureOn(center, address, lng, lat) {
      this.blogForm.hostCity = center + address;
      this.blogForm.situatio = [lng, lat];
      // this.center = center;
      // this.address = address;
    },
    openMapDialog() {
      this.$refs.bmapAddressSelect.revealShow();
    },
    // 获取标签
    getLabel() {
      this.$http
        .get("match/getLabel", {
          params: {
            page_size: 9999,
            page_index: 1,
          },
        })
        .then((res) => {
          if (res.status !== 200) return;
          this.labelList = res.data.blogs;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    beforeUnloadHandler(e) {
      var e = window.event || e;
      e.returnValue = "您的修改尚未保存，确认要离开吗?"; // 此处返回任意字符串，不返回null即可，不能修改默认提示内容
    },
    changeFormCheckList(formCheckList) {
      this.formCheckList = formCheckList;
    },
    onReady(editor) {
      // Insert the toolbar before the editable area.
      editor.ui
        .getEditableElement()
        .parentElement.insertBefore(
          editor.ui.view.toolbar.element,
          editor.ui.getEditableElement()
        );
    },
    customPaste(editor, event) {
      let items = event.clipboardData.items;
      console.log("进来了");
      // 获取粘贴的html部分（？？没错粘贴word时候，一部分内容就是html），该部分包含了图片img标签
      let html = event.clipboardData.getData("text/html");

      // 获取rtf数据（从word、wps复制粘贴时有），复制粘贴过程中图片的数据就保存在rtf中
      const rtf = event.clipboardData.getData("text/rtf");

      if (html && rtf) {
        // 该条件分支即表示要自定义word粘贴

        // 列表缩进会超出边框，直接过滤掉
        html = html.replace(/text\-indent:\-(.*?)pt/gi, "");

        // 从html内容中查找粘贴内容中是否有图片元素，并返回img标签的属性src值的集合
        const imgSrcs = this.findAllImgSrcsFromHtml(html);

        // 如果有
        // if (imgSrcs && Array.isArray(imgSrcs) && imgSrcs.length) {
        // 从rtf内容中查找图片数据
        const rtfImageData = this.extractImageDataFromRtf(rtf);

        // 如果找到
        if (rtfImageData.length) {
          // TODO：此处可以将图片上传到自己的服务器上

          // 执行替换：将html内容中的img标签的src替换成ref中的图片数据，如果上面上传了则为图片路径
          html = this.replaceImagesFileSourceWithInlineRepresentation(
            html,
            imgSrcs,
            rtfImageData
          );
          editor.dangerouslyInsertHtml(html);
        }
        // }

        // 阻止默认的粘贴行为
        event.preventDefault();
        return false;
      } else {
        return true;
      }
    },
    /**
     * 从rtf内容中匹配返回图片数据的集合
     * @param rtfData
     * @return Array
     */
    extractImageDataFromRtf(rtfData) {
      if (!rtfData) {
        return [];
      }

      const regexPictureHeader =
        /{\\pict[\s\S]+?({\\\*\\blipuid\s?[\da-fA-F]+)[\s}]*/;
      const regexPicture = new RegExp(
        "(?:(" + regexPictureHeader.source + "))([\\da-fA-F\\s]+)\\}",
        "g"
      );
      const images = rtfData.match(regexPicture);
      const result = [];

      if (images) {
        for (const image of images) {
          let imageType = false;

          if (image.includes("\\pngblip")) {
            imageType = "image/png";
          } else if (image.includes("\\jpegblip")) {
            imageType = "image/jpeg";
          }

          if (imageType) {
            result.push({
              hex: image
                .replace(regexPictureHeader, "")
                .replace(/[^\da-fA-F]/g, ""),
              type: imageType,
            });
          }
        }
      }

      return result;
    },
    replaceImagesFileSourceWithInlineRepresentation(
      htmlData,
      imageSrcs,
      imagesHexSources,
      isBase64Data = true
    ) {
      if (imageSrcs.length === imagesHexSources.length) {
        for (let i = 0; i < imageSrcs.length; i++) {
          const newSrc = isBase64Data
            ? `data:${imagesHexSources[i].type};base64,${_convertHexToBase64(
                imagesHexSources[i].hex
              )}`
            : imagesHexSources[i];

          htmlData = htmlData.replace(imageSrcs[i], newSrc);
        }
      }

      return htmlData;
    },
    /**
     * 从html代码中匹配返回图片标签img的属性src的值的集合
     * @param htmlData
     * @return Array
     */
    findAllImgSrcsFromHtml(htmlData) {
      let imgReg = /<img.*?(?:>|\/>)/gi; //匹配图片中的img标签
      let srcReg = /src=[\'\"]?([^\'\"]*)[\'\"]?/i; // 匹配图片中的src

      let arr = htmlData.match(imgReg); //筛选出所有的img
      if (!arr || (Array.isArray(arr) && !arr.length)) {
        return false;
      }

      let srcArr = [];
      for (let i = 0; i < arr.length; i++) {
        let src = arr[i].match(srcReg);
        // 获取图片地址
        srcArr.push(src[1]);
      }

      return srcArr;
    },
    onCreated(editor) {
      this.editor = Object.seal(editor); // 一定要用 Object.seal() ，否则会报错
    },
    sendArticleUrl() {
      var reg = /http(s)?:\/\/([\w-]+\.)+[\w-]+(\/[\w- .\/?%&=]*)?/;
      if (!reg.test(this.articleUrl)) {
        return this.$message.error(
          "以https://开头的公众号文章，且必须是个有效链接~"
        );
      }
      let load = this.$loading({
        text: "解析中...",
      });
      this.$http
        .post("/match/articleUrl", {
          articleUrl: this.articleUrl,
        })
        .then((res) => {
          if (res.data.code == "0") {
            this.html = res.data.data;
          } else {
            this.$message.error("解析失败");
          }
          load.close();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 获取信息
    getDetail(id) {
      this.$http
        .get("/match/getDetail", {
          params: {
            id,
          },
        })
        .then((res) => {
          if (res.status !== 200) return;
          let data = res.data.data;
          if (!data.length) {
            this.$message.error("该资讯已失效");
            setTimeout(() => {
              this.$router.push("/matchList");
            }, 2000);
            return;
          } else {
            this.projectTags = data[0].projectTags;
            this.projectTags.forEach((item) => {
              item.ageLimit = item.ageLimit ? JSON.parse(item.ageLimit) : [];
            });
            this.formCheckList = data[0].formCheckList
              ? JSON.parse(data[0].formCheckList)
              : this.formCheckList;
            this.uniteTags = data[0].uniteTags;
            this.addedTags = data[0].addedTags;
            this.blogForm.parser = data[0].parser;
            this.blogForm.classId = data[0].classId;
            this.blogForm.title = data[0].title;
            this.blogForm.hostCity = data[0].hostCity;
            this.blogForm.matchName = data[0].matchName;
            this.blogForm.matchPlace = data[0].matchPlace;
            this.blogForm.refundRatio = data[0].refundRatio;
            this.blogForm.score = data[0].score;
            this.blogForm.scoreNumber = data[0].scoreNumber;
            this.blogForm.weixinLink = data[0].weixinLink;
            this.blogForm.matchOrganizer = data[0].matchOrganizer;
            this.blogForm.relateLabel = data[0].relateLabel;
            this.blogForm.openLottery = !!data[0].openLottery;
            this.blogForm.openUnite = !!data[0].openUnite;
            this.blogForm.lotteryNumber = data[0].lotteryNumber;
            this.blogForm.introduceType =
              (!data[0].introduceType
                ? data[0].weixinLink
                  ? "2"
                  : "1"
                : data[0].introduceType) + "";
            this.blogForm.situatio = data[0].situatio
              ? JSON.parse(data[0].situatio)
              : [];
            this.blogForm.isRefund = data[0].isRefund == 1 ? true : false;
            this.blogForm.openTeam = data[0].openTeam == 1 ? true : false;
            this.blogForm.noticeText = data[0].noticeText;
            this.blogForm.refundeEnd = data[0].refundeEnd
              ? data[0].refundeEnd
              : new Date().getTime();
            this.blogForm.infoEndTime = data[0].infoEndTime
              ? data[0].infoEndTime
              : new Date().getTime();
            this.blogForm.status = data[0].status + "";
            this.blogForm.matchTime.push(data[0].matchStartTime);
            this.blogForm.matchTime.push(data[0].matchEndTime);
            if (data[0].lotteryStartTime) {
              this.blogForm.lotteryTime.push(data[0].lotteryStartTime);
            }
            if (data[0].lotteryEndTime) {
              this.blogForm.lotteryTime.push(data[0].lotteryEndTime);
            }
            if (data[0].registStartTime) {
              this.blogForm.registTime.push(data[0].registStartTime);
            }
            if (data[0].registEndTime) {
              this.blogForm.registTime.push(data[0].registEndTime);
            }
            this.blogForm.signUpUrl = data[0].signUpUrl;
            this.blogForm.follows = data[0].follows;
            this.blogForm.openSignUp = !!data[0].openSignUp;
            this.html = data[0].introduce;
            if (!data[0].imgUrl.includes("http") && data[0].imgUrl) {
              this.format = "2";
              this.blogForm.imgUrl = data[0].imgUrl;
            } else {
              this.blogForm.imgUrlLink = data[0].imgUrl;
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 获取分类
    getClass() {
      this.$http
        .get("/match/getClass")
        .then((res) => {
          console.log(res);
          if (res.status !== 200) return;
          this.options = res.data.blogs;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 创建富文本
    createWangEditor() {
      //   创建富文本编辑器
      let that = this;
      var editor = new E({
        selector: "#editor",
        mode: "default",
      });
      // 或者 var editor = new E( document.getElementById('editor') )
      // 配置服务器端地址
      editor.customConfig.uploadImgServer =
        that.$http.defaults.baseURL + "/upload";
      //自定义 fileName
      editor.customConfig.uploadFileName = "img";
      //自定义 header
      editor.customConfig.uploadImgHeaders = {
        Accept: "multipart/form-data",
      };
      // editor.customConfig.linkCheck = function (text, link) {
      //   console.log(text); // 插入的文字
      //   console.log(link); // 插入的链接

      //   return true; // 返回 true 表示校验成功
      //   // return '验证失败' // 返回字符串，即校验失败的提示信息
      // };
      editor.customConfig.uploadImgHooks = {
        success: function (xhr, editor, result) {
          console.log("图片上传并返回结果,图片插入成功");
        },
        fail: function (xhr, editor, result) {
          console.log("图片上传并返回结果，但图片插入错误");
        },
        error: function (xhr, editor) {
          console.log("图片上传出错");
        },
        timeout: function (xhr, editor) {
          console.log("图片上传超时");
        },
        customInsert: function (insertImg, result, editor) {
          // 上传成功 result为后台处理函数返回的数据
          var url = that.$http.defaults.resource + result.data;
          insertImg(url); //根据返回的图片路径，将图片插入到页面中，回显
        },
      };
      editor.create();
      this.editor = editor;
    },
    // 资讯发布
    issueBlog(formName) {
      // 表单验证
      let that = this;
      that.$refs[formName].validate((valid) => {
        if (valid) {
          var reg = /http(s)?:\/\/([\w-]+\.)+[\w-]+(\/[\w- .\/?%&=]*)?/;
          if (that.blogForm.imgUrlLink) {
            if (this.format == "1" && !reg.test(that.blogForm.imgUrlLink)) {
              return this.$message.error(
                "封面图片必须以http://或者https://开头，且必须是个有效链接~"
              );
            }
          }
          if (that.blogForm.openSignUp && !that.projectTags.length) {
            return this.$message.error("请添加报名项目");
          }
          if (that.blogForm.openUnite && !that.uniteTags.length) {
            return this.$message.error("请添加团报优惠");
          }
          if (this.format == "2") {
            that.blogForm.imgUrlLink = "";
          }
          // 计算开始和结束时间
          let minTime = that.projectTags[0]
            ? that.projectTags[0].effectStartTime
            : 0;
          let maxTime = that.projectTags[0]
            ? that.projectTags[0].effectEndTime
            : 0;
          that.projectTags.forEach((item) => {
            if (item.effectStartTime < minTime) {
              minTime = item.effectStartTime;
            }
            if (
              item.groupEffectStartTime &&
              item.groupEffectStartTime < minTime &&
              this.blogForm.openUnite
            ) {
              minTime = item.groupEffectStartTime;
            }
            if (item.effectEndTime > maxTime) {
              maxTime = item.effectEndTime;
            }
            if (
              item.groupEffectEndTime &&
              item.groupEffectEndTime > maxTime &&
              this.blogForm.openUnite
            ) {
              maxTime = item.groupEffectEndTime;
            }
          });
          //   发送请求
          let load = this.$loading();
          that.$http
            .post(`/match/modifyDetail?id=${this.$route.query.id}`, {
              matchInfo: {
                // adminId: JSON.parse(localStorage.getItem("admins")).id,
                title: that.blogForm.title,
                parser: that.blogForm.parser,
                classId: that.blogForm.classId,
                imgUrl: that.blogForm.imgUrlLink || that.blogForm.imgUrl,
                hostCity: that.blogForm.hostCity,
                matchName: that.blogForm.matchName,
                matchPlace: that.blogForm.matchPlace,
                matchOrganizer: that.blogForm.matchOrganizer,
                signUpUrl: that.blogForm.signUpUrl,
                refundRatio: that.blogForm.refundRatio,
                weixinLink: that.blogForm.weixinLink,
                follows: that.blogForm.follows,
                openSignUp: that.blogForm.openSignUp,
                openLottery: that.blogForm.openLottery,
                openUnite: that.blogForm.openUnite,
                situatio: JSON.stringify(that.blogForm.situatio),
                lotteryNumber: that.blogForm.lotteryNumber,
                relateLabel: that.blogForm.relateLabel,
                status: parseInt(that.blogForm.status),
                matchStartTime: new Date(that.blogForm.matchTime[0]).getTime(),
                matchEndTime: new Date(that.blogForm.matchTime[1]).getTime(),
                isRefund: that.blogForm.isRefund ? 1 : 0,
                openTeam: that.blogForm.openTeam ? 1 : 0,
                introduceType: parseInt(that.blogForm.introduceType),
                noticeText: that.blogForm.noticeText,
                score: that.blogForm.score + "",
                scoreNumber: that.blogForm.scoreNumber,
                refundeEnd: new Date(that.blogForm.refundeEnd).getTime(),
                infoEndTime: new Date(that.blogForm.infoEndTime).getTime(),
                registStartTime: minTime ? new Date(minTime).getTime() : 0,
                registEndTime: maxTime ? new Date(maxTime).getTime() : 0,
                lotteryStartTime:
                  that.blogForm.lotteryTime && that.blogForm.lotteryTime[0]
                    ? new Date(that.blogForm.lotteryTime[0]).getTime()
                    : 0,
                lotteryEndTime:
                  that.blogForm.lotteryTime && that.blogForm.lotteryTime[1]
                    ? new Date(that.blogForm.lotteryTime[1]).getTime()
                    : 0,
                introduce: that.html,
                formCheckList: JSON.stringify(this.formCheckList),
              },
              projectTags: this.projectTags,
              uniteTags: this.uniteTags,
              addedTags: this.addedTags,
            })
            .then((res) => {
              load.close();
              if (res.status !== 200) {
                this.$message({
                  showClose: true,
                  message: "修改失败",
                  type: "error",
                });
                return;
              }
              if (res.data.code == -1) {
                this.$message({
                  showClose: true,
                  message: res.data.message,
                  type: "error",
                });
                return;
              }
              this.$message({
                showClose: true,
                message: "修改成功",
                type: "success",
              });
              // this.blogForm = {
              //   classId: "",
              //   imgUrlLink: "",
              //   // 博客标题
              //   imgUrl: "",
              //   title: "",
              //   hostCity: "",
              //   matchName: "",
              //   matchPlace: "",
              //   matchOrganizer: "",
              //   matchTime: [],
              //   registTime: [],
              //   signUpUrl: "",
              //   follows: 0,
              //   introduce: "",
              // };
              // this.html = "<p></p>";
              if (window.opener) {
                // 调用父窗口函数
                window.opener.getInfo();
              }
              setTimeout(() => {
                window.removeEventListener(
                  "beforeunload",
                  this.beforeUnloadHandler,
                  false
                );
                window.opener = null;
                window.close();
              }, 1000);
            })
            .catch((err) => {
              load.close();
              this.$message.error(err.message);
              console.log("失败");
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 上传成功
    handleAvatarSuccess(res, file) {
      if (res && res.code == 0) {
        this.blogForm.imgUrl = res.data;
      } else {
        this.$message({
          showClose: true,
          message: "上传失败",
          type: "error",
        });
      }
      this.$refs.blogForm.validateField("imgUrl");
    },
    // 上传之前
    beforeAvatarUpload(file) {
      let ftype = file.type === "image/jpeg" || file.type === "image/png";

      if (!ftype) {
        this.$message.error("上传图片只能是 JPG 或 PNG格式!");
      }
      //设置文件大小限制
      const isLt10M = file.size / 1024 / 1024 < 1;
      if (!isLt10M) {
        this.$message.error("上传的照片大小不能超过 1MB!");
        return false;
      }
      const isLt1M = file.size / 1024 / 1024 < 0.1;
      if (!isLt1M) {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = (event) => {
            const img = new Image();
            img.src = event.target.result;
            img.onload = () => {
              const canvas = document.createElement("canvas");
              const ctx = canvas.getContext("2d");
              canvas.width = img.width;
              canvas.height = img.height;
              ctx.drawImage(img, 0, 0, img.width, img.height);

              // Adjust the quality (0.5 for 50% quality, for example)
              const dataUrl = canvas.toDataURL("image/jpeg", 0.5);
              // Convert the data URL back to a File object
              const compressedFile = this.dataURLtoFile(dataUrl, file.name);

              resolve(compressedFile);
            };
          };
        });
      }
      return ftype;
    },
    dataURLtoFile(dataurl, filename) {
      var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);

      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }

      return new File([u8arr], filename, { type: mime });
    },
    // cancel
    cancel() {
      window.opener = null;
      window.close();
      // window.opener = null;
      // window.open("about:blank", "_top").close();
    },
    handleClose(tag) {
      let index = this.projectTags.indexOf(tag);
      // this.$http
      //   .delete(`/match/deleteRelate/?id=${this.dynamicTags[index].id}`)
      //   .then((res) => {
      this.projectTags.splice(index, 1);
      //   });
    },
  },

  beforeDestroy() {
    const editor = this.editor;
    if (editor == null) return;
    editor.destroy(); // 组件销毁时，及时销毁编辑器
  },
};
</script>
<style lang="less" scoped>
form {
  margin-top: 30px;
  width: 100%;
  padding: 0 40px 100px;
}
#editor {
  margin-top: 0px;
}
.el-tag {
  margin-right: 10px;
}

// 上传部分
.avatar-uploader /deep/ .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader /deep/ .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 150px;
  height: 150px;
  line-height: 150px;
  text-align: center;
}
.avatar {
  width: 150px;
  height: 150px;
  display: block;
}
</style>
